document.documentElement.classList.add('js');
(function(){
  /* --- mobile menu --- */
  var hdr=document.querySelector('.hdr'),burger=document.querySelector('.burger');
  if(burger&&hdr)burger.addEventListener('click',function(){hdr.classList.toggle('is-open');});

  /* --- scroll reveal --- */
  var els=[].slice.call(document.querySelectorAll('[data-reveal]'));
  function showAll(){els.forEach(function(el){el.classList.add('is-in');});}
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(!e.isIntersecting)return;var el=e.target;var i=el.parentElement?[].indexOf.call(el.parentElement.children,el):0;el.style.animationDelay=Math.min(i,5)*70+'ms';el.classList.add('is-in');io.unobserve(el);});},{threshold:.12,rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el);});
    setTimeout(showAll,2500);
  }else{showAll();}

  /* --- product gallery --- */
  var mainImg=document.querySelector('[data-main-image]');
  var thumbs=[].slice.call(document.querySelectorAll('[data-thumb]'));
  thumbs.forEach(function(t){
    t.addEventListener('click',function(){
      if(mainImg)mainImg.src=t.dataset.full;
      thumbs.forEach(function(x){x.classList.remove('is-active');});
      t.classList.add('is-active');
    });
  });

  /* --- product variant switching --- */
  var pform=document.getElementById('product-form');
  if(pform){
    var view=[];
    var el=document.querySelector('[data-variant-view]');
    if(el){try{view=JSON.parse(el.textContent);}catch(e){view=[];}}
    var selects=[].slice.call(pform.querySelectorAll('.product__option'));
    var idInput=pform.querySelector('[data-variant-id]');
    var priceEl=document.querySelector('[data-price]');
    var btn=pform.querySelector('[data-add-btn]');
    var label=pform.querySelector('[data-add-label]');

    function chosen(){return selects.map(function(s){return s.value;});}
    function match(opts){
      return view.filter(function(v){
        return v.options.length===opts.length && v.options.every(function(o,i){return o===opts[i];});
      })[0];
    }
    function update(){
      var v=selects.length?match(chosen()):view[0];
      if(!v){
        if(btn){btn.disabled=true;label.textContent=btn.dataset.unavailableText;}
        if(idInput)idInput.value='';
        return;
      }
      if(idInput)idInput.value=v.id;
      if(priceEl)priceEl.textContent=v.price;
      if(btn){
        btn.disabled=!v.available;
        label.textContent=v.available?btn.dataset.addText:btn.dataset.soldText;
      }
      if(v.image&&mainImg){
        mainImg.src=v.image;
        thumbs.forEach(function(t){t.classList.toggle('is-active',String(t.dataset.mediaId)===String(v.media_id));});
      }
    }
    selects.forEach(function(s){s.addEventListener('change',update);});
    update();
  }
})();
